import { useEffect, useState } from 'react'
import { Moon, Sun } from 'lucide-react'
import { getTheme, toggleTheme } from '../lib/theme'

export default function ThemeToggle() {
  const [theme, setThemeState] = useState(() => getTheme())

  useEffect(() => {
    const sync = (e) => {
      if (!e.key || e.key === 'opraiz:theme') setThemeState(getTheme())
    }
    window.addEventListener('storage', sync)
    return () => window.removeEventListener('storage', sync)
  }, [])

  const handle = () => setThemeState(toggleTheme())

  return (
    <button
      type="button"
      className="icon-btn icon-btn--ghost"
      onClick={handle}
      aria-label="Toggle theme"
      aria-pressed={theme === 'light'}
      title={theme === 'light' ? 'Switch to dark' : 'Switch to light'}
    >
      {theme === 'light' ? <Moon aria-hidden="true" /> : <Sun aria-hidden="true" />}
    </button>
  )
}
